// actions.js
import { createAction } from '@reduxjs/toolkit';

export const setData = createAction('setData');
